const ExternalRoute = ({ url }) => {
    window.location.href = url;
    return null;
};

export default ExternalRoute;
